export default __webpack_public_path__ + "static/media/kosmos-small.7b205d15.jpg";